var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m3.626 18.625 1.748 1.748 1.694-.753L21.595 5.095a1.902 1.902 0 0 0-2.69-2.69L17.561 3.75l1.72 1.72-1.061 1.06L16.5 4.81 4.379 16.931zM17.845 1.344a3.402 3.402 0 1 1 4.81 4.81L8.08 20.73a1.1 1.1 0 0 1-.338.233l-5.796 2.576a1.125 1.125 0 0 1-1.484-1.485l2.575-5.796q.085-.19.233-.338z"
})));
export default SvgEditSmall;